<style lang="less">
// @import "../less/common.less";
@import "./staff.less";
.label-tips.keyboard-modal {
  .el-dialog {
    max-width: 400px;
    .el-dialog__body {
      padding: 0;
      border-radius: 8px;
      overflow: hidden;
    }
  }
}
</style>
<template>
  <div class="staff">
    <div class="staff-body"
         id="staff-body">
      <el-button class="page-btn-detail"
                 type="text"
                 @click="toDetailReport">单据详情</el-button>
      <div class="staff-content"
           :style="{height:height+'px'}">
        <div class="content-detail">
          <div class="content-data"
               id="content-data"
               v-bind:class="{ isModal: isModal }">
            <div class="show-detail">
              <div class="code">编码</div>
              <div class="name">产品名称</div>
              <div class="price">单价</div>
              <div class="num">数量</div>
            </div>
            <div class="detail-result"
                 :style="{maxHeight:height-150+'px'}">
              <slideDel :list="tableDataResultStr"
                        @confirmDel="confirmDel"></slideDel>
            </div>
            <div class="total-table"
                 v-if="tableDataResult&&tableDataResult.length>0">合计数量：{{totalNum}}&nbsp;&nbsp;&nbsp;&nbsp;合计金额：{{totalPrice}}</div>
            <div class="content-bnt">
              <el-button class="but-confirm"
                         type="primary"
                         @click="showDialog">确定</el-button>
              <el-button class="but-cancel"
                         @click="cancel">重置</el-button>
            </div>
          </div>
          <div class="content-search">
            <div class="search-btn">
              <div>
                <div class="label">选择模板:</div>
                <div class="content"
                     id="template-id">
                  <el-radio-group v-model="templateID"
                                  size="medium"
                                  @change="changeTemplateID">
                    <el-radio v-for="item in templateList"
                              :label="item.id"
                              :key="item.id"
                              border>{{item.name}}</el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div>
                <div class="label">完工人:</div>
                <div class="content"
                     id="staff-id">
                  <el-radio-group v-model="staffID"
                                  size="medium">
                    <el-radio v-for="item in staffList"
                              :label="item.id"
                              :key="item.id"
                              border>{{item.name}}</el-radio>

                  </el-radio-group>
                </div>
              </div>
            </div>
            <div class="search-list"
                 :style="{height:height-heightTemplate-heightStaff-28+'px'}">
              <el-table v-bind:class="{ isModal: isModal }"
                        :data="tableDataTemp"
                        border
                        :row-class-name="tableRowClassName"
                        :height="height-heightTemplate-heightStaff-38"
                        @row-click="handleCurrentChange">
                <el-table-column prop="productCode"
                                 label="编码"
                                 width="120">
                </el-table-column>
                <el-table-column prop="productName"
                                 label="产品名称">
                </el-table-column>
                <el-table-column prop="productPrice"
                                 header-align="center"
                                 align="right"
                                 label="单价">
                  <!-- <template slot-scope="scope">
                    ¥{{scope.row.productPrice}}
                  </template> -->
                </el-table-column>
                <el-table-column prop="num"
                                 header-align="center"
                                 align="center"
                                 label="数量"
                                 width="204">
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 提示框 start -->
    <ModalTips class="label-tips"
               :dialogVisible="dialogVisible"
               @close-modal="confirm">
      <div slot="content">
        <i class="el-icon-warning"></i>
        <span>您确认保存完工入库单？</span>
      </div>
    </ModalTips>
    <!-- 提示框 end -->
    <!-- 提示框 start -->
    <ModalTips class="label-tips"
               :dialogVisible="resetDialogVisible"
               @close-modal="reset">
      <div slot="content">
        <i class="el-icon-warning"></i>
        <span>您确认清空当前完工入库单信息？</span>
      </div>
    </ModalTips>
    <!-- 提示框 end -->
    <!-- 切换模板提示框 start -->
    <ModalTips class="label-tips"
               :dialogVisible="tempDialogVisible"
               @close-modal="tempConfirm">
      <div slot="content">
        <i class="el-icon-warning"></i>
        <span>当前模板已输入完工数量，重新选择模板会清空当前数量，您确认切换模板？</span>
      </div>
    </ModalTips>
    <!-- 切换模板提示框 end -->
    <!-- 键盘输入 start -->
    <ModalTips class="label-tips keyboard-modal"
               :dialogVisible="keyDialogVisible"
               :isFooter="false"
               @close-modal="keyConfirm">
      <div slot="content">
        <keyboard :dialogVisible="keyDialogVisible"
                  @confirmEvent="confirmEvent"></keyboard>
      </div>
    </ModalTips>
    <!-- 键盘输入 end -->
  </div>
</template>
<script>
import $ from "jquery";
import loginApi from "@/api/api-login";
import staffApi from "@/api/api-staff";
import materialTemplateApi from "@/api/api-materialTemplate";
import completionBillApi from "@/api/api-completionBill";
import { Message } from "element-ui";
// import FooterC from "@/components/modal/FooterC";
import common from "@/libs/common";
import screenfull from 'screenfull'
import ModalTips from "@/components/modal/modalTips";
import keyboard from "@/components/keyboard";
import slideDel from "@/components/slideDel";
import { localToken } from "@/libs/util";
let loading;
export default {
  name: "main",
  props: {
    isModalOld: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      Verification: true, //通过v-show控制显示获取还是倒计时
      timer: 60, //定义初始时间为60s
      loadingBtn: false,
      fullscreen: false,
      height: $("#staff-body").height() - 90,
      width: $("#staff-body").width() - 28,
      width2: $("#content-data").width(),
      heightTemplate: 46,
      heightStaff: 46,
      templateID: null,
      staffID: null,
      templateList: [],
      staffList: [],
      tableDataTemp: [],
      tableDataResult: [],
      totalNum: 0,
      totalPrice: 0,
      dialogVisible: false,
      tempDialogVisible: false,
      resetDialogVisible: false,
      oldTempID: null,
      keyDialogVisible: false,
      // 单击弹出键盘时，获取当前编辑行
      currentRow: null,
      tableDataResultStr: '[]',
      index: null,
      index2: null,
      isModal: false
    };
  },
  components: {
    ModalTips,
    keyboard,
    slideDel
  },
  methods: {
    // 斑马线
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
      } else {
        return "success-row";
      }
      return "";
    },
    // 跳转至单据详情
    toDetailReport () {
      this.$router.push({ path: '/detailReport' });
    },
    // 右滑删除
    confirmDel (obj) {
      let that = this
      let { currentRow, index, index2 } = obj
      that.index = index
      that.index2 = index2
      that.handleTableDate(currentRow, true)
    },
    // 键盘输入后获取到的数字
    confirmEvent (s) {
      s = parseFloat(s)
      let that = this
      let currentRow = that.currentRow
      currentRow.num = s
      that.tableDataTemp[currentRow.index].num = s
      // that.$set(that.tableDataTemp, currentRow[index])
      that.handleTableDate(currentRow)
      that.keyDialogVisible = false
    },
    // 单机模板产品弹出键盘
    handleCurrentChange (row, column, event) {
      let that = this
      that.currentRow = row
      that.keyDialogVisible = true
    },
    // 关闭键盘
    keyConfirm () { this.keyDialogVisible = false },
    // 重置
    cancel () {
      if (this.tableDataResult && this.tableDataResult.length > 0) {
        this.resetDialogVisible = true
      }
    },
    reset (flag) {
      let that = this
      if (flag) {
        that.clear()
        // that.tableDataResult = []
        // that.tableDataResultStr = "[]"
        // that.tableDataTemp.map(item => {
        //   item['num'] = 0
        //   return item
        // })
        that.resetDialogVisible = false
      } else {
        that.resetDialogVisible = false
      }
    },
    clear () {
      let that = this
      that.tableDataResult = []
      that.tableDataResultStr = "[]"
      that.tableDataTemp.map(item => {
        item['num'] = 0
        return item
      })
    },
    // 添加完工信息弹出框确认框
    showDialog () {
      let that = this
      if (that.tableDataResult.length == 0) {
        that.$message({
          showClose: true,
          duration: 800,
          message: "请添加完工信息!",
          center: true,
          type: "error"
        });
      } else {
        that.dialogVisible = true
      }
    },
    // 确定保存完工单
    confirm (flag) {
      let that = this
      if (flag) {
        let data = {
          staffId: that.staffID,
          completionBillContent: that.tableDataResult.map(item => {
            return {
              "productId": item.productId,
              "productPrice": item.productPrice,
              "num": item.num
            }
          })
        }
        that.saveCompletionBill(data).then(res => {
          that.$message({
            showClose: true,
            duration: 800,
            message: "保存完工单成功!",
            center: true,
            type: "info"
          });
          that.dialogVisible = false
          that.clear()
          that.getTemplateDetail(that.templateID, true)
        }, err => {
          that.dialogVisible = false
          that.$message({
            showClose: true,
            duration: 800,
            message: "保存完工单失败!",
            center: true,
            type: "error"
          });
          console.log(err)
        })
      } else {
        that.dialogVisible = false
      }
    },
    // 修改数量
    handleTableDate (row, flag = false) {
      let that = this
      let i = 0
      that.tableDataResult = that.tableDataResult.map((item, index) => {
        if (item.productId === row.productId) {
          item['num'] = typeof row.num === 'undefined' || (flag && that.index == index) ? 0 : row.num
          i++
        }
        return item
      })
      if (i === 0) {
        that.tableDataResult.push(row)
      }
      that.tableDataResult = that.tableDataResult.filter(item => { return item.num != 0 }).map(item => item)

      let totalNum = 0
      let totalPrice = 0
      if (that.tableDataResult.length > 0) {
        that.tableDataResult.map(item => {
          // let num = parseFloat(item.num)
          totalNum += item.num
          totalPrice += item.num * item.productPrice
        })
      }
      // that.tableDataResult = that.tableDataResult.concat(that.tableDataResult).concat(that.tableDataResult).concat(that.tableDataResult)
      that.totalNum = common.toDecimal3(totalNum)
      that.totalPrice = common.toDecimal3(totalPrice)
      that.tableDataResultStr = JSON.stringify(that.tableDataResult)
    },
    // 切换模板确认按钮
    tempConfirm (flag) {
      let that = this
      if (flag) {
        that.tableDataResult = []
        that.tableDataResultStr = '[]'
        that.getTemplateDetail(that.templateID, true)
        that.oldTempID = that.templateID
      } else {
        that.templateID = that.oldTempID
      }
      that.tempDialogVisible = false
    },
    // 切换按钮
    changeTemplateID (val) {
      let that = this
      let tableDataResult = that.tableDataResult
      if (tableDataResult.length > 0) {
        that.tempDialogVisible = true
      } else {
        that.oldTempID = val
        that.getTemplateDetail(that.templateID, true)
      }
    },
    // 保存完工单
    saveCompletionBill (data) {
      return new Promise((resolve, reject) => {
        completionBillApi
          .saveCompletionBill(data)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 完工人列表
    // getStaff () {
    //   return new Promise((resolve, reject) => {
    //     staffApi
    //       .getStaff()
    //       .then(res => {
    //         resolve(res);
    //       })
    //       .catch(err => {
    //         reject(err);
    //       });
    //   });
    // },
    // 获取模板列表
    getMaterialTemplate () {
      return new Promise((resolve, reject) => {
        materialTemplateApi
          .getMaterialTemplate()
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 获取模板列表
    getMaterialTemplateDetail (id) {
      return new Promise((resolve, reject) => {
        materialTemplateApi
          .getMaterialTemplateDetail(id)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getTemplateDetail (id, flag = false) {
      let that = this
      if (flag) {
        loading = that.$loading({
          lock: true,
          text: "拼命加载中...",
          spinner: "el-icon-loading",
          background: "rgba(255, 255, 255, 0.7)"
        });
      }
      that.getMaterialTemplateDetail(id).then(res => {
        that.tableDataTemp = res.items.map((item, index) => {
          // item['productPrice'] = '¥' + item.productPrice
          // 根据已经设置数量恢复数据
          let arr = that.tableDataResult.filter(opt => {
            if (opt.productId === item.productId) {
              return opt
            }
          })
          if (arr.length > 0) {
            item['num'] = arr[0].num
          } else {
            item['num'] = 0
          }
          item['index'] = index
          return item
        })
        // that.tableDataTemp = that.tableDataTemp.concat(that.tableDataTemp).concat(that.tableDataTemp)
        setTimeout(loading.close(), 500)
      }, err => {
        console.log(err)
      })
    },
    init () {
      let that = this
      loading = that.$loading({
        lock: true,
        text: "拼命加载中...",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)"
      });
      Promise.all([common.getStaff(), that.getMaterialTemplate()])
        .then(
          res => {
            // 完工人
            if (res[0] && res[0].length > 0) {
              that.staffID = res[0][0].id
              that.staffList = res[0]
            }
            // 选择模板
            if (res[1] && res[1].length > 0) {
              that.templateID = res[1][0].id
              that.templateList = res[1]
            }

            that.$nextTick(() => {
              that.height = $("#staff-body").height() - 80;
              that.width = $("#staff-body").width() - 28;
              that.heightTemplate = $("#template-id").height();
              that.heightStaff = $("#staff-id").height();
              that.width2 = $("#content-data").width()

            });
            if (res[1] != null && res[1].length > 0) {
              that.getTemplateDetail(that.templateID)
            } else {
              that.$nextTick(() => {
                loading.close();
              });
              that.$message({
                showClose: true,
                duration: 2800,
                message: "请先设置模板!",
                center: true,
                type: "error"
              });
            }

          },
          err => {
            that.$nextTick(() => {
              loading.close();
            });
          }
        )
        .catch(err => {
          that.$nextTick(() => {
            loading.close();
          });
        });
    }
  },
  mounted () {
    this.init()
  },
  destroyed () {
    if (loading) {
      loading.close();
    }
  },
  // 监听模态框，记录当前页面是否有模态框弹出
  watch: {
    isModalOld (newval, val) {
      this.isModal = newval
    },
    dialogVisible (newval, val) {
      this.isModal = newval
    },
    resetDialogVisible (newval, val) {
      this.isModal = newval
    },
    tempDialogVisible (newval, val) {
      this.isModal = newval
    },
    keyDialogVisible (newval, val) {
      this.isModal = newval
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/view/main/main.vue